// src/components/Admin/VehicleTable.jsx
import React from "react";

export default function VehicleTable({
  vehicles = [],
  openEditModal,
  onDelete,
}) {
  const fmtPrice = (val) => {
    const n = Number(val);
    if (!Number.isFinite(n)) return "—";
    return n % 1 === 0 ? `$${n}` : `$${n.toFixed(2)}`;
  };

  const confirmDelete = async (id) => {
    if (!onDelete) return;
    if (!window.confirm("Delete this vehicle?")) return;
    await onDelete(id);
  };

  return (
    <div className="overflow-x-auto">
      <table className="min-w-full divide-y divide-gray-200 dark:divide-slate-700">
        <thead>
          <tr className="text-left text-xs font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-400">
            <th className="px-3 py-2">Model</th>
            <th className="px-3 py-2">Year</th>
            <th className="px-3 py-2">Type</th>
            <th className="px-3 py-2">Seats</th>
            <th className="px-3 py-2">Price</th>
            <th className="px-3 py-2">Action</th>
          </tr>
        </thead>

        <tbody className="divide-y divide-gray-100 dark:divide-slate-800 text-sm">
          {vehicles.length === 0 && (
            <tr>
              <td className="px-3 py-6 text-center text-gray-500 dark:text-gray-400" colSpan={6}>
                No vehicles found.
              </td>
            </tr>
          )}

          {vehicles.map((v) => (
            <tr key={v.id} className="hover:bg-gray-50 dark:hover:bg-slate-700/50">
              <td className="px-3 py-3 whitespace-nowrap">{v.model || "—"}</td>
              <td className="px-3 py-3 whitespace-nowrap">{v.year || "—"}</td>
              <td className="px-3 py-3 whitespace-nowrap">{v.type || "—"}</td>
              <td className="px-3 py-3 whitespace-nowrap">{v.seats ?? v.number_of_seats ?? "—"}</td>
              <td className="px-3 py-3 whitespace-nowrap">{fmtPrice(v.price_per_day)}</td>
              <td className="px-3 py-3">
                <div className="flex items-center gap-4">
                  <button
                    type="button"
                    onClick={() => openEditModal && openEditModal(v)}
                    className="text-blue-600 hover:text-blue-700 dark:text-blue-300 dark:hover:text-blue-200 underline-offset-2 hover:underline"
                  >
                    Edit
                  </button>
                  <button
                    type="button"
                    onClick={() => confirmDelete(v.id)}
                    className="text-rose-600 hover:text-rose-700 dark:text-rose-300 dark:hover:text-rose-200 underline-offset-2 hover:underline"
                  >
                    Delete
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
